import { User } from '@gc-bridge/services';
import { create } from 'zustand';

interface CurrentUserStore {
  user: User | undefined;
  setUser: (user: User | undefined) => void;
}

export const useCurrentUserStore = create<CurrentUserStore>()((set) => ({
  user: undefined,
  setUser: (user) => set({ user }),
}));
